import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "..";
import { envConfig } from "../../constants/config";
import { UserMetaInfo } from "../../constants/types";

interface AuthState {
  authToken: string | null;
  user: UserMetaInfo | null;
  error: boolean;
  loading: boolean;
}

// create slice

const name = "auth";
const initialState: AuthState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState(): AuthState {
  return {
    authToken: localStorage.getItem("token")
      ? JSON.parse(localStorage.getItem("token") ?? "")
      : null,
    // initialize state from local storage to enable user to stay logged in
    user: null,
    error: false,
    loading: false,
  };
}

function createReducers() {
  return {
    logout,
  };

  function logout(state: AuthState) {
    state.authToken = null;
    state.user = null;
    localStorage.removeItem("token");
  }
}

function createExtraActions() {
  return {
    login: login(),
    getUser: getUser(),
  };

  function login() {
    return createAsyncThunk(
      `${name}/login`,
      async ({ email, password }: { email: string; password: string }) =>
        await axios.post(`${envConfig.BASE_URL}/auth/login?app_name=yodha`, {
          email: email,
          password: password,
          app_origin: "yodha",
        })
    );
  }

  function getUser() {
    return createAsyncThunk(
      `${name}/getUser`,
      async (a, { getState }) => {
        const authUser = getState() as RootState;
        return await axios.get(`${envConfig.BASE_URL}/me`, {
          headers: {
            Authorization: `Bearer ${authUser.auth.authToken}`,
          },
          params: {
            apiToken: authUser.auth.authToken,
            app_name: "yodha",
          },
        });
      } //
    );
  }
}

function createExtraReducers() {
  return {
    ...login(),
    ...getUser(),
  };

  function login() {
    const { pending, fulfilled, rejected }: any = extraActions.login;
    return {
      [pending]: (state: AuthState) => {
        state.error = false;
        state.loading = true;
      },
      [fulfilled]: (
        state: AuthState,
        action: PayloadAction<{ data: { data: { token: string } } }, string>
      ) => {
        const auth = action.payload.data.data;
        localStorage.setItem("token", JSON.stringify(auth.token));
        state.authToken = auth.token;
        state.loading = false;
        state.error = false;
      },
      [rejected]: (state: AuthState) => {
        state.error = true;
        state.loading = false;
      },
    };
  }

  function getUser() {
    const { pending, fulfilled, rejected }: any = extraActions.getUser;
    return {
      [pending]: (state: AuthState) => {
        state.error = false;
        state.loading = true;
      },
      [fulfilled]: (
        state: AuthState,
        action: PayloadAction<{ data: { data: UserMetaInfo } }, string>
      ) => {
        const user = action.payload.data.data;
        state.user = user;
        state.loading = false;
        state.error = false;
      },
      [rejected]: (state: AuthState) => {
        state.error = true;
        state.loading = false;
      },
    };
  }
}
